import { Injectable } from '@angular/core';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
@Injectable({
  providedIn: 'root'
})
export class InputValidationsService {

  constructor() { }

  
  //////////////////////////
  // Form field validations
  //////////////////////////
  emailValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      if (!control.value || control.value.trim() === '') {
        return null; // If empty, consider it valid
      }
  
      const emailRegex = /@.*\.(com|in|co\.in|gov\.in|nic\.in|ac\.in|org\.in|org|net|info|biz)$/;
      const isValid = emailRegex.test(control.value.trim()); 
      return isValid ? null : { 'invalidEmail': { value: control.value } };
    };
  }

  noSpacesValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const hasSpaces = (control.value || '').toString().trim().includes(' ');
      return hasSpaces ? { 'noSpaces': true } : null;
    };
  }

  maxLengthValidator(maxLength: number): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const value = control.value;
      if (value && value.length > maxLength) {
        return { 'maxLengthExceeded': { maxLength: maxLength, actualLength: value.length } };
      }
      return null;
    };
  }

  atLeastOneItemSelectedValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      return value && value.length > 0 ? null : { atLeastOneItemSelected: true };
    };
  }

  valueNotZeroValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      return value === 0 ? { notZero: true } : null;
    };
  }

  arrayNotEmptyValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (Array.isArray(value) && value.length === 0) {
        return { arrayNotEmpty: true };
      }
      return null;
    };
  }

  validateWebsiteUrl(control: AbstractControl): ValidationErrors | null {
    const urlPattern = /^(https?:\/\/)?(www\.)?[a-zA-Z0-9-]+\.[a-zA-Z]{2,}(\/.*)?$/;
    const value = control.value;
    if (!value) {
      return null;
    }  
    if (!urlPattern.test(value)) {
      return { invalidUrl: true };
    }
    return null;
  }

  textEditorRequired(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value || typeof control.value !== 'string') {
        return { textEditorRequired: true };
      }
      const strippedContent = control.value.replace(/<[^>]*>/g, '').trim();
  
      if (!strippedContent) {
        return { textEditorRequired: true };
      }
      return null;
    };
  }

  minMaxRangeValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const minRange = control.get('minRange')?.value;
      const maxRange = control.get('maxRange')?.value;
  
      if (minRange !== null && maxRange !== null) {
        if (minRange > maxRange) {
          return { invalidRange: true }; // Custom error key
        }
      }
      
      return null; // No errors
    };
  }

  domainNameValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const domainName = (control.value || '').trim();

      if (!domainName) {
        return null;
      }

      // Allow subdomains, restrict TLD to .com, .org, or .in
      const domainRegex = /^(?!-)(?:[a-zA-Z0-9](?:[a-zA-Z0-9\-]{0,61}[a-zA-Z0-9])?\.)+(com|org|in)$/i;

      const isValid = domainRegex.test(domainName);
      return isValid ? null : { 'invalidDomain': { value: control.value } };
    };
  }
}
